<ng-template #templateModalAvaliacao>
    <div class="modal-avaliacao">
        <div class="modal-header">
            @if (!selectedOrder) {
                <section class="modal-title">
                    <div class="icon">
                        <i-feather name="thumbs-up"></i-feather>
                    </div>
                    {{'buyer.visao-geral.avaliacao.modal.titulo' | translate}}
                </section>
            } @else {
                <section class="modal-title">
                    <div class="btn btn-primary back-to-orders" (click)="selectOrder(null)">
                        <i-feather name="arrow-left"></i-feather>
                    </div>
                    #{{selectedOrder.order_id}} - {{selectedOrder.veiculo}}
                </section>
            }
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="close();"></button>
        </div>
        <div class="modal-body">
            <div class="d-flex flex-wrap">
                <header>
                    @if (!selectedOrder) {
                        <div class="col-0-25">{{'buyer.visao-geral.avaliacao.modal.tabela.cabecalho.pedido' | translate}}</div>
                        <div class="col header-vendedor">{{'buyer.visao-geral.avaliacao.modal.tabela.cabecalho.vendedor' | translate}}</div>
                        <div class="col-2">{{'buyer.visao-geral.avaliacao.modal.tabela.cabecalho.veiculo' | translate}}</div>
                        <div class="col-0-5">{{'buyer.visao-geral.avaliacao.modal.tabela.cabecalho.data' | translate}}</div>
                        <div class="col-0-5">{{'buyer.visao-geral.avaliacao.modal.tabela.cabecalho.avaliacao' | translate}}</div>
                    } @else {
                        <div class="col-2">{{'buyer.visao-geral.avaliacao.modal.tabela.cabecalho.peca' | translate}}</div>
                        <div class="col">{{'buyer.visao-geral.avaliacao.modal.tabela.cabecalho.situacao' | translate}}</div>
                        <div class="col">{{'buyer.visao-geral.avaliacao.modal.tabela.cabecalho.data-prevista' | translate}}</div>
                        <div class="col">{{'buyer.visao-geral.avaliacao.modal.tabela.cabecalho.data-entrega' | translate}}</div>
                    }
                </header>
                <ng-scrollbar>
                    @if (!selectedOrder) {
                        <div>
                            @for (avaliacao of avaliacoes; track avaliacao) {
                                <div class="avaliacao" [ngClass]="{'negative': !avaliacao.foi_bom}">
                                    <div class="red-line" [ngClass]="{'negative': !avaliacao.foi_bom}"></div>
                                    <div class="linha">
                                        <div class="col-0-25 col-pedido" (click)="selectOrder(avaliacao)">
                                            {{avaliacao.order_id}}
                                        </div>
                                        <div class="col col-vendedor">
                                            <span>
                                                <i-feather name="user"></i-feather>
                                                <p class="truncate">{{avaliacao.vendedor}}</p>
                                            </span>
                                            <p class="truncate">{{avaliacao.fornecedor}}</p>
                                        </div>
                                        <div class="col-2 col-veiculo">
                                            {{avaliacao.veiculo}}
                                        </div>
                                        <div class="col-0-5 col-data">
                                            {{avaliacao.creation_date | date:'dd/MM/yyyy'}}
                                        </div>
                                        <div class="col-0-5 col-avaliacao">
                                            <div class="thumbs thumbs-up" [ngClass]="{'selected': avaliacao.foi_bom}" (click)="changeAvaliacao(avaliacao, 1)">
                                                <i-feather name="thumbs-up"></i-feather>
                                            </div>
                                            <div class="thumbs thumbs-down" [ngClass]="{'selected': !avaliacao.foi_bom}" (click)="changeAvaliacao(avaliacao, 0)">
                                                <i-feather name="thumbs-down"></i-feather>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="comment-input" [ngClass]="{'invalid': avaliacao.isInvalid}" >
                                        <label for="comment-{{avaliacao.id}}">{{'buyer.visao-geral.avaliacao.modal.tabela.validacao.comentario.obrigatorio' | translate}}:</label>
                                        <textarea [(ngModel)]="avaliacao.avaliacao_texto" placeholder="{{'buyer.visao-geral.avaliacao.modal.tabela.validacao.comentario.placeholder' | translate}}" id="comment-{{avaliacao.id}}" type="text"></textarea>
                                    </div>
                                </div>
                            }
                        </div>
                    } @else {
                        @for (part of selectedOrder.pecas; track part) {
                            <div class="linha">
                                <div class="col-2"> {{part.nome}} </div>
                                <div class="col"> {{part.situacao}} </div>
                                <div class="col col-data"> {{part.data_prevista ? part.data_prevista : '-'}} </div>
                                <div class="col col-data"> {{part.data_entrega ? part.data_entrega : '-'}} </div>
                            </div>
                        }
                    }
                </ng-scrollbar>
            </div>
        </div>
        <div class="modal-footer">
            @if (!selectedOrder) {
                <button class="btn btn-outline" (click)="rememberInTwoHours()">{{'buyer.visao-geral.avaliacao.modal.botoes.lembrar-duas-horas' | translate}}</button>
                <button class="btn btn-primary" (click)="rateAllOrders()">{{'buyer.visao-geral.avaliacao.modal.botoes.avaliar' | translate}}</button>
            }
        </div>
    </div>
    <ngx-ui-loader [loaderId]="'loader-avaliacao'"></ngx-ui-loader>
</ng-template>
